<template>
    <el-dialog
        class="center-dialog"
        title="需求类型"
        :visible="value"
        @update:visible="handleVisibleChange"
        width="700"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
    >
        <div class="dialog-body">
            <div class="body-filter">
                <el-input v-model="keyword" placeholder="搜索需求类型" size="small">
                    <template slot="prefix">
                        <i class="el-icon-search"></i>
                    </template>
                </el-input>

                <!-- 搜索弹框结果 -->
                <el-scrollbar class="filter-box" v-if="keyword">
                    <template v-if="filterList.length > 0">
                        <div class="filter-item" v-for="item in filterList" :key="item.id" @click="handleChangeType(item, true)">
                            <span>{{ item.text }}</span>

                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </template>

                    <div class="no-filter" v-else>暂无数据</div>
                </el-scrollbar>
            </div>

            <div class="change-box">
                <!-- 分类一级label -->
                <div class="change-box_left">
                    <div
                        :class="['list-item', { active: item.id === current }]"
                        v-for="item in list"
                        :key="item.id"
                        @click="current = item.id"
                    >
                        <span class="ellipsis-single">{{ item.name }}</span>

                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>

                <div class="change-box_right">
                    <!-- 分类二级列表 -->
                    <div class="type-list" v-if="currentTab.length > 0">
                        <div
                            :class="['type-item', { active: item.id === checkType }]"
                            v-for="item in currentTab"
                            :key="item.id"
                            @click="handleChangeType(item)"
                        >
                            {{ item.name }}
                        </div>
                    </div>

                    <template v-else>
                        <div class="right-empty" style="display: flex; align-items: center; justify-content: center; padding-top: 180px">
                            暂无数据
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleConfirm" style="background: #594fed">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name: "ChangeTypeDialog",
    data() {
        return {
            keyword: "",
            current: null, // 选中的一级分类
            checkType: null, // 选中的类型
        };
    },

    model: {
        prop: "value",
        event: "input",
    },

    props: {
        value: {
            type: Boolean,
            required: true,
        },
        type: {
            type: Number,
        },
        list: {
            type: Array,
            default: () => [],
        },
    },

    watch: {
        value(val) {
            if (val) {
                if (this.list.length > 0) this.current = this.list[0].id;

                this.checkType = this.type;
            }
        },
    },

    computed: {
        currentTab() {
            const findTab = this.list.find((item) => item.id === this.current);
            return findTab?.children || [];
        },

        filterList() {
            const list = [];

            this.list.forEach((item) => {
                if (item.name.includes(this.keyword)) {
                    list.push(
                        ...item.children.map((c) => {
                            return {
                                text: `${item.name} / ${c.name}`,
                                id: c.id,
                                parent: item.id,
                                name: c.name,
                            };
                        })
                    );
                } else {
                    list.push(
                        ...item.children
                            .filter((item) => item.name.includes(this.keyword))
                            .map((c) => ({
                                text: `${item.name} / ${c.name}`,
                                id: c.id,
                                parent: item.id,
                                name: c.name,
                            }))
                    );
                }
            });

            return list;
        },
    },

    methods: {
        handleVisibleChange(val) {
            this.$emit("input", val);
        },

        // 点击过滤分类
        handleChangeType(val, parent = false) {
            this.keyword = "";
            this.checkType = val.id;

            if (parent) this.current = val.parent;
        },

        handleConfirm() {
            this.$emit("confirm", this.checkType);

            this.reset();
            this.$emit("input", false);
        },

        reset() {
            this.current = null;
            this.checkType = null;
            this.keyword = "";
        },
    },
};
</script>

<style lang="scss" scoped>
.dialog-body {
    .body-filter {
        border-radius: 4px 4px 0 0;
        border: 1px solid #e1e3e5;
        position: relative;

        ::v-deep(.el-input__prefix) {
            display: flex;
            align-items: center;
            font-size: 20px;
        }

        ::v-deep(.el-input__inner) {
            border: none;
        }

        .filter-box {
            position: absolute;
            top: calc(100% + 1px);
            left: 0;
            height: 449px;
            width: 100%;
            background-color: #fff;

            ::v-deep(.el-scrollbar__wrap) {
                margin: 0 !important;

                &::-webkit-scrollbar {
                    display: none;
                }
            }

            .filter-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 32px;
                padding-inline: 12px;
                border-bottom: 1px solid #e1e3e5;
                cursor: pointer;

                &:hover {
                    background-color: #594fed0c;
                }
            }

            .no-filter {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 449px;
            }
        }
    }

    .change-box {
        height: 450px;
        border: 1px solid #e1e3e5;
        border-top: none;
        border-radius: 0 0 4px 4px;
        display: flex;

        &_left {
            border-right: 1px solid #e1e3e5;
            width: 144px;
            height: 100%;
            overflow-y: scroll;

            &::-webkit-scrollbar {
                display: none;
            }

            .list-item {
                --color: #333333;
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-inline: 20px;
                margin-top: 10px;
                cursor: pointer;
                color: var(--color);

                span {
                    display: inline-block;
                }

                &.active {
                    background-color: #eeedfd;
                    --color: #594fed;
                }
            }
        }

        &_right {
            flex: 1;
            height: 100%;
            overflow-y: scroll;
            padding: 16px;

            &::-webkit-scrollbar {
                display: none;
            }

            .type-list {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;

                .type-item {
                    font-weight: 400;
                    font-size: 12px;
                    color: #333333;
                    line-height: 30px;
                    padding: 1px 12px;
                    background: #ffffff;
                    border-radius: 2px;
                    border: 1px solid #ebebeb;
                    cursor: pointer;

                    &.active {
                        background: #eeedfd;
                        border-color: #756deb;
                        color: #594fed;
                    }
                }
            }
        }
    }
}
</style>
